import { StyleSheet, Text, View } from "react-native";
import React, { useEffect, useState, useMemo} from "react";
import { Box, Icon, Progress, ProgressFilledTrack, Typography } from "components/ui";
import { ArrowRightFromLine, Check, CheckCircle, CreditCard, ReceiptText, Package, Truck } from "lucide-react-native";
import { useSegments } from "expo-router";
import { useIsMobile } from "utils/hooks/useIsMobile";

type OrderProgressProps = {
	orderStatus: string | undefined | null;
};

const OrderProgress = ({ orderStatus }: OrderProgressProps) => {
	const isMobile = useIsMobile();
	const checkoutProgress = [
		{ title: "Processing", icon: ReceiptText, id: 1 },
		{ title:
			orderStatus === "Partially Delivered" ?  "Partially Delivered" : 
			orderStatus === "Ready For Pickup" ? "Ready for pickup" : "In transit",
			icon: orderStatus ==="Ready For Pickup" ? Package : Truck, id: 2 },
		{ title: isMobile ? "Complete" : "Complete", icon: ArrowRightFromLine, id: 3 },
	];

	const stepValue = useMemo(() => {
		if (!orderStatus) return 1;

		switch (orderStatus) {
			case "Complete":
				return 3;
			case "Partially Delivered":
				return 2;
			case "In Transit":
				return 2;
			case "Ready For Pickup":
				return 2;
			default:
				return 1;
		}
	}, [orderStatus]);

	return (
		<View>
			<Box marginTop={isMobile ? 0 : 20} marginBottom={isMobile ? 0 : 20} borderRadius={12} paddingHorizontal={isMobile ? 16 : 32} paddingVertical={24} bg={"$neutral25"}>
				<Box flexDirection="row" marginBottom={isMobile ? 8 : 16} justifyContent="space-around">
					{checkoutProgress.map((step, index) => {
						return (
							<Box key={index} flex={1} alignItems="center" justifyContent="center">
								<Box
									backgroundColor={stepValue > step.id ? "$primarylightblue" : ""}
									alignItems="center"
									justifyContent="center"
									borderWidth={1}
									aspectRatio={1}
									width={40}
									borderColor={stepValue === step.id ? "$primarylightblue" : "$neutral100"}
									borderRadius={"$full"}
								>
									{stepValue > step.id ? (
										<Icon as={Check} color={stepValue === step.id ? "$primarylightblue" : "$neutral100"} aspectRatio={1} width={24} />
									) : (
										<Icon as={step.icon} color={stepValue === step.id ? "$primarylightblue" : "$neutral100"} aspectRatio={1} width={24} />
									)}
								</Box>
								<Typography
									sx={{
										color: stepValue === step.id || stepValue > step.id ? "$basicblack" : "$neutral100",
										fontSize: isMobile ? 14 : 16,
									}}
									weight="bold"
								>
									{step.title}
								</Typography>
							</Box>
						);
					})}
				</Box>
				<Progress bg={"$neutral100"} value={(stepValue / 3) * 100} w={"$full"} size={isMobile ? "md" : "lg"}>
					<ProgressFilledTrack bg="$primarylightblue" />
				</Progress>
			</Box>
		</View>
	);
};

export default OrderProgress;
